module.exports = __webpack_public_path__ + "assets/timeline.e1f33d43.svg";